import {
  AdminTableHeader,
  adminFilterDateInputClasses,
  adminFilterDropdownTriggerClass,
} from '../shared/adminUx';
/**
 * Maps static seed rows onto recent calendar dates so date filters (e.g. Last 30 Days)
 * match demo data regardless of wall-clock year in the seed file.
 */
const withRecentDemoDates = (txns) => {
  const now = new Date();
  return txns.map((txn, i) => {
    const daysAgo = i % 35;
    const transactionDate = new Date(now);
    transactionDate.setDate(transactionDate.getDate() - daysAgo);
    transactionDate.setHours(6 + (i % 12), (i * 7) % 60, 0, 0);

    const renewalDate = new Date(transactionDate);
    const isYearly = String(txn.planType || '').toLowerCase().includes('yearly');
    if (isYearly) {
      renewalDate.setFullYear(renewalDate.getFullYear() + 1);
    } else {
      renewalDate.setMonth(renewalDate.getMonth() + 1);
    }

    const lastUpdated = new Date(transactionDate);
    lastUpdated.setMinutes(lastUpdated.getMinutes() + 30);

    return {
      ...txn,
      date: transactionDate.toISOString(),
      renewalDate: renewalDate.toISOString(),
      lastUpdated: lastUpdated.toISOString(),
    };
  });
};

const financeTransactionsRaw = [
  {
    id: 'TXN-008732',
    businessName: 'Werribee Plumbing Pty Ltd',
    businessId: 'BUS-9934',
    posterProfileId: 96,
    memberSince: '2024-03-12',
    businessLogo: 'https://i.pravatar.cc/120?img=32',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Success',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '4242',
    date: '2025-10-10T08:45:00+11:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp99TYC',
    gst: 9.0,
    renewalDate: '2025-11-10T08:45:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19032',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    lastUpdated: '2025-10-12T11:40:00+11:00',
    auditLog: [
      { timestamp: '2025-10-10T09:02:00+11:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
      { timestamp: '2025-10-10T09:05:00+11:00', actor: 'Admin-01', action: 'Viewed payment details', notes: '—' },
      { timestamp: '2025-10-10T09:07:00+11:00', actor: 'Admin-01', action: 'Sent receipt', notes: 'Receipt emailed to billing contact' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Admin-01',
        timestamp: '2025-10-10T09:15:00+11:00',
        content: 'Business confirmed automatic renewal is expected.',
      },
      {
        id: 'note-2',
        author: 'Finance QA',
        timestamp: '2025-10-12T11:40:00+11:00',
        content: 'Verified GST calculation matches Stripe invoice.',
      },
    ],
  },
  {
    id: 'TXN-008731',
    businessName: 'Northside Electrical Services',
    businessId: 'BUS-7184',
    posterProfileId: 7184,
    memberSince: '2024-01-08',
    businessLogo: 'https://i.pravatar.cc/120?img=45',
    planType: 'Basic (Monthly)',
    planKey: 'Basic',
    status: 'Success',
    amount: 49.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '5521',
    date: '2025-10-08T11:12:00+11:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp452SD',
    gst: 4.45,
    renewalDate: '2025-11-08T11:12:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19031',
    lineItems: [
      { description: 'Basic Plan (Monthly)', quantity: 1, amount: 44.55 },
      { description: 'GST (10%)', quantity: 1, amount: 4.45 },
    ],
    auditLog: [
      { timestamp: '2025-10-08T11:25:00+11:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
    ],
    lastUpdated: '2025-10-08T12:05:00+11:00',
    notes: [
      {
        id: 'note-1',
        author: 'Admin-02',
        timestamp: '2025-10-08T12:05:00+11:00',
        content: 'Requested updated billing contact email for future invoices.',
      },
    ],
  },
  {
    id: 'TXN-008729',
    businessName: 'Coastal Gas & Heating',
    businessId: 'BUS-6409',
    posterProfileId: 6409,
    memberSince: '2023-11-22',
    businessLogo: 'https://i.pravatar.cc/120?img=27',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Failed',
    amount: 99.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '9176',
    date: '2025-10-05T17:32:00+11:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp7KK66',
    gst: 9.0,
    renewalDate: '2025-10-12T17:32:00+11:00',
    responseCode: 'card_declined',
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19028',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    lastUpdated: '2025-10-06T09:22:00+11:00',
    auditLog: [
      { timestamp: '2025-10-05T17:33:00+11:00', actor: 'System', action: 'Payment failed', notes: 'card_declined' },
      { timestamp: '2025-10-05T17:45:00+11:00', actor: 'Admin-02', action: 'Viewed payment details', notes: 'Follow-up required with business' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-02', timestamp: '2025-10-05T18:05:00+11:00', content: 'Stripe retry scheduled in 24 hours.' },
      {
        id: 'note-2',
        author: 'Risk Team',
        timestamp: '2025-10-06T09:22:00+11:00',
        content: 'Monitoring account for repeat failures before escalation.',
      },
    ],
  },
  {
    id: 'TXN-008724',
    businessName: 'Bolt Electrical Group',
    businessId: 'BUS-3810',
    posterProfileId: 3810,
    memberSince: '2023-06-15',
    businessLogo: 'https://i.pravatar.cc/120?img=14',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Refunded',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '3189',
    date: '2025-09-28T13:10:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp2LJJ9',
    gst: 9.0,
    renewalDate: '2025-10-28T13:10:00+11:00',
    responseCode: null,
    refund: {
      status: 'Refunded',
      amount: 99.0,
      date: '2025-09-29T09:45:00+10:00',
      reference: 're_3Q8WsL2eZvKYlo2C2Gh98OPL',
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19024',
    lastUpdated: '2025-09-30T08:15:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-28T13:12:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Initial payment accepted' },
      { timestamp: '2025-09-29T09:45:00+10:00', actor: 'System', action: 'Refund issued', notes: 'Processed automatically from Stripe' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-03', timestamp: '2025-09-29T10:00:00+10:00', content: 'Refund confirmed with business owner.' },
      {
        id: 'note-2',
        author: 'Finance QA',
        timestamp: '2025-09-30T08:15:00+10:00',
        content: 'Refund exported to monthly reconciliation sheet.',
      },
    ],
  },
  {
    id: 'TXN-008722',
    businessName: 'Rapid Roofing Specialists',
    businessId: 'BUS-2224',
    posterProfileId: 2224,
    memberSince: '2023-08-22',
    businessLogo: 'https://i.pravatar.cc/120?img=18',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Disputed',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '8831',
    date: '2025-09-25T10:18:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpZXT91',
    gst: 9.0,
    renewalDate: '2025-10-25T10:18:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'In Review',
      reason: 'Service not recognised',
      reference: 'dp_3Q8WsL2eZvKYlo2CdHJ892Ls',
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19022',
    lastUpdated: '2025-10-04T14:42:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-25T10:20:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
      { timestamp: '2025-09-30T15:32:00+10:00', actor: 'System', action: 'Dispute opened', notes: 'Awaiting evidence submission' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-04', timestamp: '2025-09-30T16:05:00+10:00', content: 'Stripe case opened, monitoring outcome.' },
      { id: 'note-2', author: 'Admin-02', timestamp: '2025-10-02T09:12:00+10:00', content: 'Requested supporting docs from business owner.' },
      {
        id: 'note-3',
        author: 'Risk Team',
        timestamp: '2025-10-04T14:42:00+10:00',
        content: 'Submitted evidence pack to Stripe case portal.',
      },
    ],
  },
  {
    id: 'TXN-008720',
    businessName: 'Bright Spark Electrical',
    businessId: 'BUS-5583',
    posterProfileId: 5583,
    memberSince: '2024-02-10',
    businessLogo: 'https://i.pravatar.cc/120?img=12',
    planType: 'Basic (Monthly)',
    planKey: 'Basic',
    status: 'Success',
    amount: 49.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '1045',
    date: '2025-09-20T08:02:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp12ABC',
    gst: 4.45,
    renewalDate: '2025-10-20T08:02:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19020',
    lineItems: [
      { description: 'Basic Plan (Monthly)', quantity: 1, amount: 44.55 },
      { description: 'GST (10%)', quantity: 1, amount: 4.45 },
    ],
    lastUpdated: '2025-09-20T10:12:00+10:00',
    auditLog: [
      { timestamp: '2025-09-20T08:04:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Support',
        timestamp: '2025-09-20T10:12:00+10:00',
        content: 'Confirmed receipt email delivered to accounts@brightspark.com.au.',
      },
    ],
  },
  {
    id: 'TXN-008718',
    businessName: 'Metro HVAC Solutions',
    businessId: 'BUS-4102',
    posterProfileId: 4102,
    memberSince: '2023-09-01',
    businessLogo: 'https://i.pravatar.cc/120?img=37',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Success',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '6610',
    date: '2025-09-18T09:40:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1Gp66MET',
    gst: 9.0,
    renewalDate: '2025-10-18T09:40:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19018',
    lastUpdated: '2025-09-18T10:05:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-18T09:41:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Finance QA',
        timestamp: '2025-09-18T10:05:00+10:00',
        content: 'Checked card on file — expiry mid 2026.',
      },
    ],
  },
  {
    id: 'TXN-008716',
    businessName: 'Evergreen Landscaping Co.',
    businessId: 'BUS-6025',
    posterProfileId: 6025,
    memberSince: '2024-01-20',
    businessLogo: 'https://i.pravatar.cc/120?img=43',
    planType: 'Basic (Monthly)',
    planKey: 'Basic',
    status: 'Pending',
    amount: 49.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '8842',
    date: '2025-09-16T07:55:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpPEND1',
    gst: 4.45,
    renewalDate: '2025-10-16T07:55:00+11:00',
    responseCode: 'requires_action',
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19017',
    lastUpdated: '2025-09-17T09:25:00+10:00',
    lineItems: [
      { description: 'Basic Plan (Monthly)', quantity: 1, amount: 44.55 },
      { description: 'GST (10%)', quantity: 1, amount: 4.45 },
    ],
    auditLog: [
      { timestamp: '2025-09-16T07:56:00+10:00', actor: 'System', action: 'Payment requires action', notes: 'Awaiting customer authentication' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-06', timestamp: '2025-09-16T08:10:00+10:00', content: 'Customer notified to complete 3DS challenge.' },
      {
        id: 'note-2',
        author: 'Support',
        timestamp: '2025-09-17T09:25:00+10:00',
        content: 'Sent reminder SMS about authentication deadline.',
      },
    ],
  },
  {
    id: 'TXN-008714',
    businessName: 'Harbour City Pest Control',
    businessId: 'BUS-7741',
    posterProfileId: 7741,
    memberSince: '2023-05-12',
    businessLogo: 'https://i.pravatar.cc/120?img=49',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Failed',
    amount: 99.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '3309',
    date: '2025-09-14T12:22:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpFAIL1',
    gst: 9.0,
    renewalDate: '2025-09-21T12:22:00+10:00',
    responseCode: 'insufficient_funds',
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19016',
    lastUpdated: '2025-09-14T13:05:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-14T12:23:00+10:00', actor: 'System', action: 'Payment failed', notes: 'insufficient_funds' },
      { timestamp: '2025-09-14T12:50:00+10:00', actor: 'Admin-05', action: 'Sent follow-up email', notes: 'Requested updated card details' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Collections',
        timestamp: '2025-09-14T13:05:00+10:00',
        content: 'Waiting 48 hours before initiating manual follow-up.',
      },
    ],
  },
  {
    id: 'TXN-008711',
    businessName: 'Precision Plumbing & Gas',
    businessId: 'BUS-1193',
    posterProfileId: 1193,
    memberSince: '2024-04-08',
    businessLogo: 'https://i.pravatar.cc/120?img=55',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Refunded',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '1098',
    date: '2025-09-12T15:05:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpREFD1',
    gst: 9.0,
    renewalDate: '2025-10-12T15:05:00+11:00',
    responseCode: null,
    refund: {
      status: 'Refunded',
      amount: 99.0,
      date: '2025-09-13T09:20:00+10:00',
      reference: 're_3Q8WsL2eZvKYlo2C2GhREFD1',
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19015',
    lastUpdated: '2025-09-13T10:05:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-12T15:06:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
      { timestamp: '2025-09-13T09:20:00+10:00', actor: 'System', action: 'Refund issued', notes: 'Requested by business via Stripe' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Support',
        timestamp: '2025-09-13T10:05:00+10:00',
        content: 'Business acknowledged refund and will update accounts payable.',
      },
    ],
  },
  {
    id: 'TXN-008709',
    businessName: 'Coastal Cleaning Collective',
    businessId: 'BUS-5412',
    posterProfileId: 5412,
    memberSince: '2023-07-30',
    businessLogo: 'https://i.pravatar.cc/120?img=61',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Disputed',
    amount: 99.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '7780',
    date: '2025-09-10T10:18:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpDSPT1',
    gst: 9.0,
    renewalDate: '2025-10-10T10:18:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'In Review',
      reason: 'Duplicate charge claimed',
      reference: 'dp_3Q8WsL2eZvKYlo2DSPT1',
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19014',
    lastUpdated: '2025-09-20T11:32:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-10T10:19:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
      { timestamp: '2025-09-18T08:12:00+10:00', actor: 'System', action: 'Dispute opened', notes: 'Evidence requested from business' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-01', timestamp: '2025-09-18T09:02:00+10:00', content: 'Collecting supporting documents for dispute response.' },
      {
        id: 'note-2',
        author: 'Risk Team',
        timestamp: '2025-09-20T11:32:00+10:00',
        content: 'Provided cardholder statement to Stripe via dashboard upload.',
      },
    ],
  },
  {
    id: 'TXN-008705',
    businessName: 'Urban Tree Services',
    businessId: 'BUS-3305',
    posterProfileId: 3305,
    memberSince: '2024-05-14',
    businessLogo: 'https://i.pravatar.cc/120?img=53',
    planType: 'Basic (Monthly)',
    planKey: 'Basic',
    status: 'Success',
    amount: 49.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '5411',
    date: '2025-09-05T06:45:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpTREE1',
    gst: 4.45,
    renewalDate: '2025-10-05T06:45:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19013',
    lastUpdated: '2025-09-05T07:05:00+10:00',
    lineItems: [
      { description: 'Basic Plan (Monthly)', quantity: 1, amount: 44.55 },
      { description: 'GST (10%)', quantity: 1, amount: 4.45 },
    ],
    auditLog: [
      { timestamp: '2025-09-05T06:46:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Support',
        timestamp: '2025-09-05T07:05:00+10:00',
        content: 'Business confirmed renewal reminder email received.',
      },
    ],
  },
  {
    id: 'TXN-008702',
    businessName: 'Peak Performance Fitness',
    businessId: 'BUS-8821',
    posterProfileId: 8821,
    memberSince: '2023-11-05',
    businessLogo: 'https://i.pravatar.cc/120?img=63',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Success',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '4221',
    date: '2025-09-02T18:30:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpGYM1',
    gst: 9.0,
    renewalDate: '2025-10-02T18:30:00+11:00',
    responseCode: null,
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19012',
    lastUpdated: '2025-09-02T19:05:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-09-02T18:31:00+10:00', actor: 'System', action: 'Payment succeeded', notes: 'Stripe webhook processed' },
    ],
    notes: [
      {
        id: 'note-1',
        author: 'Admin-02',
        timestamp: '2025-09-02T19:05:00+10:00',
        content: 'Updated finance dashboard to reflect payment success.',
      },
    ],
  },
  {
    id: 'TXN-008698',
    businessName: 'Skyline Window Cleaning',
    businessId: 'BUS-2677',
    posterProfileId: 2677,
    memberSince: '2024-06-01',
    businessLogo: 'https://i.pravatar.cc/120?img=21',
    planType: 'Basic (Monthly)',
    planKey: 'Basic',
    status: 'Failed',
    amount: 49.0,
    paymentMethod: 'Card – Mastercard (Stripe)',
    paymentBrand: 'Mastercard',
    paymentLast4: '2944',
    date: '2025-08-29T07:20:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpFAIL2',
    gst: 4.45,
    renewalDate: '2025-09-05T07:20:00+10:00',
    responseCode: 'do_not_honor',
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19011',
    lastUpdated: '2025-08-30T09:42:00+10:00',
    lineItems: [
      { description: 'Basic Plan (Monthly)', quantity: 1, amount: 44.55 },
      { description: 'GST (10%)', quantity: 1, amount: 4.45 },
    ],
    auditLog: [
      { timestamp: '2025-08-29T07:21:00+10:00', actor: 'System', action: 'Payment failed', notes: 'do_not_honor' },
    ],
    notes: [
      { id: 'note-1', author: 'Admin-03', timestamp: '2025-08-29T08:00:00+10:00', content: 'Left voicemail requesting updated payment details.' },
      {
        id: 'note-2',
        author: 'Collections',
        timestamp: '2025-08-30T09:42:00+10:00',
        content: 'Scheduled manual call if Stripe retry fails again.',
      },
    ],
  },
  {
    id: 'TXN-008695',
    businessName: 'Sunrise Home Maintenance',
    businessId: 'BUS-3488',
    posterProfileId: 3488,
    memberSince: '2023-10-18',
    businessLogo: 'https://i.pravatar.cc/120?img=28',
    planType: 'Pro (Monthly)',
    planKey: 'Pro',
    status: 'Pending',
    amount: 99.0,
    paymentMethod: 'Card – Visa (Stripe)',
    paymentBrand: 'Visa',
    paymentLast4: '9044',
    date: '2025-08-25T11:42:00+10:00',
    stripeTransactionId: 'pi_3Q8WsL2eZvKYlo2C1GpPNDG1',
    gst: 9.0,
    renewalDate: '2025-09-25T11:42:00+10:00',
    responseCode: 'authentication_required',
    refund: {
      status: 'Not Refunded',
      amount: 0,
      date: null,
      reference: null,
    },
    dispute: {
      status: 'Closed',
      reason: null,
      reference: null,
      outcomeDate: null,
    },
    invoiceNumber: 'INV-19010',
    lastUpdated: '2025-08-25T11:43:00+10:00',
    lineItems: [
      { description: 'Pro Plan (Monthly)', quantity: 1, amount: 90.0 },
      { description: 'GST (10%)', quantity: 1, amount: 9.0 },
    ],
    auditLog: [
      { timestamp: '2025-08-25T11:43:00+10:00', actor: 'System', action: 'Payment requires authentication', notes: 'Retry scheduled after customer action' },
    ],
    notes: [],
  },
];

export const financeTransactions = withRecentDemoDates(financeTransactionsRaw);

export const financeFilterOptions = {
  transactionTypes: ['All', 'Subscription', 'Renewal', 'Adjustment (proration)', 'Refund', 'Failed Charge'],
  statuses: ['All', 'Paid', 'Pending', 'Failed', 'Refunded', 'Partially Refunded'],
  plans: ['All Plans', 'Basic', 'Pro'],
  planBilling: ['All', 'Monthly', 'Yearly'],
  methods: ['All Methods', 'Visa', 'Mastercard', 'Amex', 'Other'],
  refunded: ['All', 'Yes', 'No'],
  businessStatus: ['All', 'Active', 'Suspended'],
};


